import { useBeforeUnload } from '../hooks/useBeforeUnload';
export const LeavingGuard = ({ when }) => {
    useBeforeUnload(when);
    return null;
};
